import React from 'react'

import { primaryYellow } from '../../../../lib/styles/colors'
import Banner from '../Banner'

type WarningBannerProps = {
  /** Content to display in the warning banner */
  children: React.ReactNode
  /** Optional className to apply to the banner */
  className?: string
  /** Optional icon to apply to the banner */
  icon?: React.ReactNode
}

const defaultProps = {
  className: undefined,
  icon: undefined
}

const WarningBanner = ({ children, className, icon }: WarningBannerProps) => (
  <Banner className={className} icon={icon} backgroundColor={primaryYellow} iconColor="#000">
    {children}
  </Banner>
)

WarningBanner.defaultProps = defaultProps

export default WarningBanner
